

































    
import {Vue, Component, Prop} from 'vue-property-decorator';
import { Invoice } from '../../services/accounting.service';

@Component({})
export default class InvoiceList extends Vue {
    @Prop()
    public invoices!: Invoice[];

    getValue(quote: Invoice) {
        let sum = 0;
        for (const item of quote.items) {
            sum += item.quantity * item.rate;
        }
        return sum;
    }
}

